import React from 'react';
import { PropTypes } from 'prop-types';
import './TableAccessHistory.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { EmptyFieldWarning } from 'pages/EHRPage/components/EmptyFieldWarning';
import { cpfFormat } from 'utils/AuxiliarFunctions';

library.add(faAngleLeft, faAngleRight);

export function TableAccessHistory({ table, type }) {
  return (
    <>
      {table.length > 0 ? (
        <div className="accessHistory-table">
          <div className="acessHistory-table-header">
            <p className="table-field-cpf">CPF</p>
            <p className="table-field-name">Nome</p>
            <p className="table-field-org">Organização</p>
            <p className="table-field-purpose">Motivo</p>
            <p className="table-field-data">Data</p>
            <p className="table-field-hora">Hora</p>
          </div>
          <>
            {table?.map((value, index) => (
              <div className="acessHistory-table-body" key={index}>
                <p className="table-field-cpf">
                  {value.cpf.length === 11 ? cpfFormat(value.cpf) : '-'}
                </p>
                <p className="table-field-name">{value.name}</p>
                <p className="table-field-org">{value.instituicao}</p>
                {type === 'seeAll' ? (
                  <p className="table-field-purpose">{value.purposeOfUse}</p>
                ) : (
                  <p className="table-field-purpose">Acesso Pessoal</p>
                )}

                <p className="table-field-data">{value?.date}</p>
                <p className="table-field-hora">{value?.hour}</p>
              </div>
            ))}
          </>
        </div>
      ) : (
        <EmptyFieldWarning />
      )}
    </>
  );
}

TableAccessHistory.propTypes = {
  table: PropTypes.arrayOf(PropTypes.object).isRequired,
  type: PropTypes.string.isRequired,
};
